import React from "react";
import { InView } from 'react-intersection-observer'; // Import Intersection Observer

const OurMission = () => {
  return (
    <div className="py-8"> {/* Adjusted padding */}
      <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center">

        {/* Left Section - Image */}
        <InView
          triggerOnce={true}  // Trigger animation once when element comes into view
          threshold={0.5}      // Trigger when 50% of the element is visible
        >
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`lg:w-1/2 flex justify-center transform transition-transform ${inView ? 'animate__animated animate__fadeInLeft' : ''}`}
            >
              <img
                src="https://www.sci.jfn.ac.lk/wp-content/uploads/2021/09/mission.gif"
                alt="Our Mission"
                className="w-full h-[300px] object-cover rounded-lg"
              />
            </div>
          )}
        </InView>

        {/* Right Section - Content */}
        <InView
          triggerOnce={true}  // Trigger animation once when element comes into view
          threshold={0.5}      // Trigger when 50% of the element is visible
        >
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`lg:w-1/2 text-left lg:text-left mt-4 lg:mt-0 transform transition-transform ${inView ? 'animate__animated animate__fadeInRight' : ''}`}
            >
              <h2 className="text-3xl font-bold text-gray-800 mb-2">Our Mission</h2> {/* Reduced font size and margin */}
              <p className="text-lg text-gray-600 mb-2"> {/* Reduced margin bottom */}
                At EDIT EZY, our mission is to empower individuals, businesses, and organizations with an easy-to-use design platform. We believe everyone should have access to professional design tools without the need for a graphic designer.
                <br /><br />
                We aim to simplify the process of creating eye-catching posters, business cards, and promotional materials. Whether for personal, educational, or business purposes, EDIT EZY offers a seamless, user-friendly interface to bring your creative ideas to life.
                <br /><br />
                Our goal is to make high-quality design accessible to all, saving time, effort, and resources while producing stunning results every time.
              </p>
            </div>
          )}
        </InView>

      </div>
    </div>
  );
};

export default OurMission;
